import styled from 'styled-components';
import { Typography, Stack } from '@mui/material';
import { ReactComponent as EmptyGraphic } from '../../assets/sleepy-cloud.svg';
import { FlexColumn } from '../Flex';
import { componentToken, space } from '../../style/utils';
import EmptyStateGraphic from './EmptyStateGraphic';

const Wrapper = styled(FlexColumn)`
  align-items: center;
  gap: ${space('xs')};
`;

const Message = styled(Typography).attrs(() => ({
  component: 'span',
}))`
  white-space: pre-wrap;
  text-align: center;
  color: ${componentToken('emptyState.message.color')};
  font-size: ${componentToken('emptyState.message.fontSize')};
  line-height: ${componentToken('emptyState.message.lineHeight')};
`;

const Title = styled(Typography)`
  font-size: ${componentToken('emptyState.title.fontSize')};
  font-weight: ${componentToken('emptyState.title.fontWeight')};
  line-height: ${componentToken('emptyState.title.lineHeight')};
`;

const EmptyStateBoxLink = styled.a`
  color: ${({ theme }) => theme.palette.accent.primary};
`;

const EmptyStateBoxSubTitle = styled(Message)`
  text-decoration: underline;
`;

const EmptyStateBoxClickableText = styled(Message)`
  color: ${({ theme }) => theme.palette.accent.primary};
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  title: string;
  children: React.ReactNode;
  graphic?: React.ReactNode;
};

const EmptyStateBox = ({
  title,
  children,
  graphic = <EmptyStateGraphic fallback={<EmptyGraphic />} />,
}: Props) => (
  <Wrapper>
    <Stack sx={{ mb: '16px' }}>{graphic}</Stack>

    <Title>{title}</Title>

    <Message>{children}</Message>
  </Wrapper>
);

EmptyStateBox.Link = EmptyStateBoxLink;
EmptyStateBox.SubTitle = EmptyStateBoxSubTitle;
EmptyStateBox.ClickableText = EmptyStateBoxClickableText;

export default EmptyStateBox;
